<!-- BACPayment -->
<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>
                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['เอกสารที่ต้องเตรียม', 'ประสงค์ขอทำบัตร', 'อัปโหลดเอกสาร', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="currentStep" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน
                </div>

                <div class="container font-family-bla my-3">
                    <!-- จำนวนเงิน -->
                    <h4 class="text-center fw-bold mb-4">จำนวน {{ formatBaht(amount) }} บาท</h4>

                    <div class="row g-4 align-items-center">
                        <!-- กล่องวิธีชำระ -->
                        <div class="col-12 col-lg-8 payment-box">
                            <div class="d-flex align-items-center p-3 border rounded">
                                <img :src="qrImage" alt="Thai QR Payment" class="me-3" style="width:48px;height:48px;">
                                <div>
                                    <h6 class="fw-bold mb-1">Thai QR Payment ผ่าน Mobile Banking</h6>
                                    <p class="text-muted mb-0">สแกนภาพ QR Code ที่จะได้รับหลังจากกดปุ่ม "ชำระเงิน"
                                        และชำระเงินผ่าน Mobile Banking</p>
                                </div>
                            </div>
                        </div>

                        <!-- ปุ่มชำระเงิน -->
                        <div class="col-12 col-lg-4 text-lg-end">
                            <button class="btn btn-bla btn-pay" @click="handlePayment">
                                ชำระเงิน
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

import StepBar from "../StepBar.vue";

import '@/styles/payment-qr-popup-bac.css'
import { openPaymentQrPopup } from '@/utils/payment-qr-popup-bac'

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "CardRequestType",
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            Loading: true,
            amount: 0,
            // ใช้โลโก้ placeholder (ใส่ path ของคุณเองได้)
            qrImage: new URL('@/assets/images/thaiqr.png', import.meta.url).href,
            reqCodeID: 78,
            currentStep: 3, // เพิ่ม state สำหรับ step ปัจจุบัน
        };
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.BindingData();
    },
    methods: {
        async BindingData() {
            // Call APi
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            try {
                const response = await http.get(`AgencyERequest/GetAER_TB_REQUEST_CODE?reqCodeId=${this.reqCodeID}`, {
                    headers: { Authorization: `Bearer ${AuthorizeToken}` }
                });

                if (response.status === 200 && response.data) {
                    this.amount = response.data.AMOUNT;
                } else {
                    this.swalErr(response.data?.ErrorMessage || 'ไม่สามารถดึงข้อมูลจำนวนเงินได้');
                }
            } catch (error) {
                console.error("Error fetching amount:", error);
                this.swalErr('เกิดข้อผิดพลาดในการดึงข้อมูลจำนวนเงิน');
            }
        },
        swalErr(msg) {
            Swal.fire({
                icon: 'error',
                html: `<label class="fs-5 fw-normal font-family-bla">${msg}</label>`,
                customClass: {
                    popup: 'swal-wide',
                    confirmButton: 'btn-bla'
                }
            })
        },
        formatBaht(n) {
            return Number(n).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        async handlePayment() {
            try {
                await openPaymentQrPopup();
                // เมื่อชำระเงินสำเร็จ ให้เปลี่ยน step เป็น 4 (เสร็จสิ้น)
                this.currentStep = 4;
            } catch (error) {
                console.error("Payment was cancelled or failed:", error);
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
    },
};

</script>

<style scoped>
/* โทนฟอนต์และกรอบให้เหมือน template ที่ให้มา */
.font-family-bla {
    font-family: "DB Heavent", sans-serif;
}

.payment-box .border {
    border: 1px solid #ddd !important;
    /* ขอบจางลง */
    max-width: 600px;
    /* ลดความกว้าง */
    margin: auto;
    /* จัดให้อยู่กลาง */
    background-color: #fff;
}

/* กล่องวิธีชำระ */
.pay-card {
    border: 2px solid #A2B9E2;
    border-radius: 12px;
    padding: 16px;
    background: #fff;
}

.qr-logo {
    width: 44px;
    height: 44px;
    border-radius: 8px;
}

/* ปุ่มชำระเงิน */
.btn-pay {
    width: 100%;
    min-height: 56px;
    border-radius: 10px;
    font-size: 1.1rem;
    padding-inline: 2rem;
}

@media (min-width: 992px) {
    .btn-pay {
        width: 220px;
    }
}

/* Swal QR mock */
.swal-wide {
    max-width: 520px !important;
}

.qr-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qr-img {
    width: 240px;
    height: 240px;
    border-radius: 12px;
    background:
        linear-gradient(45deg, #eee 25%, transparent 25%) -10px 0/20px 20px,
        linear-gradient(-45deg, #eee 25%, transparent 25%) -10px 0/20px 20px,
        linear-gradient(45deg, transparent 75%, #eee 75%) -10px 0/20px 20px,
        linear-gradient(-45deg, transparent 75%, #eee 75%) -10px 0/20px 20px,
        #000;
    /* กล่องดำลายสลับ ใช้แทนรูป QR จริง */
}

.card-wrap {
    border: 2px solid #A2B9E2;
    border-radius: 10px;
    background: #fff;
}

/* ให้ตัวอักษรของ input/textarea readonly & disabled เป็นสี #6D8EC9 */
.form-control[readonly],
textarea[readonly],
.form-control:disabled,
textarea:disabled,
.form-control-plaintext {
    color: #6D8EC9 !important;
    /* background-color: var(--bs-body-tertiary) !important; */
    cursor: default;
}

/* ปุ่ม: เต็มความกว้างบนมือถือ และกว้างพอดีบนจอใหญ่ */
.btn-confirm {
    width: 100%;
}

@media (min-width: 768px) {
    .btn-confirm {
        width: 25%;
        min-width: 160px;
        max-width: 320px;
    }
}

/* กรอบแดงไม่มี bg */
.alert-red-border {
    border: 2px solid var(--bs-danger);
    border-radius: 10px;
}

/* ===== Inline label + control ===== */
.inline-field {
    --label-w: 9.5rem;
    /* ปรับความกว้าง label ได้ตามต้องการ */
    display: flex;
    align-items: center;
    gap: .75rem;
}

.inline-label {
    flex: 0 0 var(--label-w);
    max-width: 50%;
    font-weight: 600;
}

.inline-control {
    flex: 1 1 auto;
    min-width: 0;
    /* กัน overflow */
}

/* มือถือ: ซ้อนเป็นแนวตั้งให้ใช้งานง่าย */
@media (max-width: 575.98px) {
    .inline-field {
        flex-direction: column;
        align-items: stretch;
    }

    .inline-label {
        flex: 0 0 auto;
        max-width: 100%;
    }
}
</style>
